export default __webpack_public_path__ + "static/media/Silk-Serif-ExtraLight.5b8668fe.otf";